export function transformWaitMusicCreate(waitMusic) {
    const { masterFilePath, name } = waitMusic;
    return {
        master_file_path: masterFilePath,
        name,
    };
}
